import { TAppFormError } from "../../../types/TAppFormError";
import TableRow from "../../atoms/TableRow";
import STPullDownRow from "../../../assets/styles/molecules/formTableRow/pullDownRow.module.scss";
import SelectBox from "../../atoms/form/SelectBox";
import { SelectBoxOption } from "../../../types/form/selectBoxOption";
import AlartMessages from "../../atoms/AlartMessages";
import validateFormRow from "../../../utils/form/validateFormRow";

type Props<T> = {
  title: string;
  subTitle?: string;
  defaultValue?: string;
  options: SelectBoxOption[];
  required?: boolean;
  formKey: T;
  errors: TAppFormError<T>[];
  setErrors: (errors: TAppFormError<T>[]) => void;
  hundleOnChange: (value: string) => void;
  isDisplay?: boolean;
  canChange?: boolean;
  maxLength?: number;
  pattern?: RegExp;
  patternText?: string;
};

const PullDownRow = <T,>({
  title,
  subTitle,
  defaultValue,
  options,
  required = false,
  formKey,
  errors,
  setErrors,
  hundleOnChange,
  isDisplay = true,
  canChange = true,
  maxLength,
  pattern,
  patternText,
}: Props<T>) => {
  const hundleChange = (input: string) => {
    validateFormRow<T>({
      input,
      errors,
      setErrors,
      formKey,
      maxLength,
      pattern,
      patternText,
      required,
    });
    hundleOnChange(input);
  };

  if (!isDisplay) return <></>;
  return (
    <TableRow key={title} title={title} subTitle={subTitle} required={required}>
      <span>
        <SelectBox
          className={canChange ? STPullDownRow.form : STPullDownRow.disable}
          name={title}
          options={options}
          defaultValue={defaultValue}
          onChange={(input) => hundleChange(input)}
        />
      </span>
      {AlartMessages<T>({
        title: title,
        errors: errors,
        keys: [formKey],
      })}
    </TableRow>
  );
};

export default PullDownRow;
